var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfxQ2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9332 12.9998C25.9332 20.1417 20.1436 25.9314 13.0018 25.9314C5.85991 25.9314 0.0703125 20.1417 0.0703125 12.9998C0.0703125 5.85795 5.85991 0.0683594 13.0018 0.0683594C20.1436 0.0683594 25.9332 5.85795 25.9332 12.9998Z",
    fill: "#009772"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6699 12.7746V10.5123H8.60156V8.5293H17.1758V10.5402H14.1074V12.7746H11.6699Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8154 11.6582C15.8833 11.6582 18.3497 12.2724 18.3506 13.0264C18.3506 13.7805 15.8838 14.3955 12.8154 14.3955C9.74722 14.3955 7.28125 13.7804 7.28125 13.0264C7.2821 12.2725 9.74775 11.6583 12.8154 11.6582ZM12.8154 11.8818C9.60512 11.8819 7.94199 12.7189 7.74023 13.0264C7.94096 13.3057 9.60391 13.7246 12.8154 13.7246C16.0559 13.7246 17.6909 13.3057 17.8916 13.0264C17.6901 12.7468 16.0263 11.8818 12.8154 11.8818Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1119 13.4734V11.9094C13.7105 11.8814 13.2803 11.8535 12.8502 11.8535C12.4487 11.8535 12.0759 11.8535 11.7031 11.8814V13.4455C12.0472 13.4455 12.4487 13.4734 12.8502 13.4734C13.2803 13.5014 13.7105 13.5014 14.1119 13.4734Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8189 14.3957C12.4175 14.3957 12.0447 14.3957 11.6719 14.3678V18.5293H14.0807V14.3398C13.6792 14.3678 13.2491 14.3957 12.8189 14.3957Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfxQ2);
export default __webpack_public_path__ + "static/media/bfx_q (2).a55c20659798b5428e9e69d6ecbf251c.svg";
export { ForwardRef as ReactComponent };